import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { ListElement } from '../ListElement/index.esm.js';
import './styles.css';


const getListAsDefault = ()=>'ul';

var styles = {
    "list": "List-module_list__Zusz2",
    "list_withBullet": "List-module_list_withBullet__v4BDv",
    "list_hasSpacing": "List-module_list_hasSpacing__JpeZk"
};

const List = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, as: Tag = getListAsDefault(), canBeManuallyFocused, hasSpacing, children }, ref)=>{
    const bulletClassName = Tag === 'ul' ? styles.list_withBullet : '';
    const spacingClassName = hasSpacing ? styles.list_hasSpacing : '';
    return /*#__PURE__*/ jsx(Tag, {
        ref: ref,
        id: id,
        className: `${styles.list} ${bulletClassName} ${spacingClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        tabIndex: canBeManuallyFocused ? -1 : undefined,
        children: children
    });
});
List.displayName = 'List';
List.Element = ListElement;
List.Element.displayName = 'List.Element';

export { List, getListAsDefault };
